import { useMutation, useQueryClient } from 'react-query';
import { QueryKeys } from '../constants';
import { IUpdateTournamentChallengeRequest, updateTournamentChallenge } from '../api/tournament';

export const useUpdateTournamentChallenge = () => {
    const queryClient = useQueryClient();

    return useMutation(
        [QueryKeys.updateTournamentChallenge],
        (data: IUpdateTournamentChallengeRequest) => updateTournamentChallenge(data),
        {
            onSuccess: (_, params) => {
                queryClient.invalidateQueries(QueryKeys.tournamentsList);
                queryClient.invalidateQueries([QueryKeys.tournament, params.tournamentId]);
            },
        }
    );
};
